import { handleActions } from 'redux-actions';
import {
  snapshotCauses,
  addDotCauses,
  markCauseSeen,
  clearExpiredDots,
  resetSeenCauses,
  setVisibleCausesCount,
} from './causesTrackingActions';

const DOT_TIMEOUT_MS =
  (parseInt(process.env.REACT_APP_NEW_RC_INDICATOR_SECONDS, 10) || 300) * 1000;

const defaultState = {
  previousPositions: {},
  dotCauses: {},
  seenCauses: {},
  visibleCausesCount: 10,
};

export default handleActions(
  {
    [snapshotCauses]: (state, action) => ({
      ...state,
      previousPositions: action.payload,
    }),
    [addDotCauses]: (state, action) => {
      const now = Date.now();
      const newDots = {};
      action.payload.forEach((uuid) => {
        if (!state.dotCauses[uuid]) {
          newDots[uuid] = now;
        }
      });
      return {
        ...state,
        dotCauses: { ...state.dotCauses, ...newDots },
      };
    },
    [markCauseSeen]: (state, action) => {
      const uuid = action.payload;
      const { [uuid]: _, ...remainingDots } = state.dotCauses;
      return {
        ...state,
        dotCauses: remainingDots,
        seenCauses: { ...state.seenCauses, [uuid]: true },
      };
    },
    [clearExpiredDots]: (state) => {
      const now = Date.now();
      const remainingDots = {};
      const newSeen = { ...state.seenCauses };
      Object.entries(state.dotCauses).forEach(([uuid, timestamp]) => {
        if (now - timestamp < DOT_TIMEOUT_MS) {
          remainingDots[uuid] = timestamp;
        } else {
          newSeen[uuid] = true;
        }
      });
      return {
        ...state,
        dotCauses: remainingDots,
        seenCauses: newSeen,
      };
    },
    [resetSeenCauses]: (state, action) => {
      const uuids = action.payload;
      const remainingSeen = { ...state.seenCauses };
      uuids.forEach((uuid) => {
        delete remainingSeen[uuid];
      });
      return {
        ...state,
        seenCauses: remainingSeen,
      };
    },
    [setVisibleCausesCount]: (state, action) => ({
      ...state,
      visibleCausesCount: action.payload,
    }),
  },
  defaultState
);
